import React from "react";
import styles from "./styles";

// MATERIAL UI
import { withStyles } from "@mui/styles";
import { Grid } from "@mui/material/";
//COMPONENTES
import Timer from "./Timer";

class TimerPoint extends React.Component {
  render() {
    const {
      timer,
      updateTimer,
      updateFinished,
    } = this.props;
    return (
      <Grid
        container
        direction="row"
        justify="center"
        alignItems="center"
        spacing={1}
        style={{ padding: "0 5% ", marginBottom: "10px", }}
      >
        <Grid item xs={12}>
          <Timer
            timer={timer}
            updateTimer={updateTimer}
            updateFinished={updateFinished}
          />
        </Grid>
      </Grid>
    );
  }
}

export default withStyles(styles)(TimerPoint);
